import type { UseFieldArrayReturn } from 'react-hook-form';

import TrashIcon from '~shared/assets/icons/trash.svg?react';
import { formatMoney } from '~shared/lib/format-money';

import { IconButton } from '@breezeventures/ui-kit/icon-button';
import { Typography } from '@breezeventures/ui-kit/typography';

import type { OrderFormValues } from '../order-form';

export const OrderItems = ({
  fields,
  remove,
}: UseFieldArrayReturn<OrderFormValues, 'items'>) => {
  return (
    <>
      {fields.map((field, index) => (
        <div
          key={field.id}
          className={`
            flex items-center justify-between gap-3 rounded-2xl border
            border-[rgba(15,15,15,0.12)] bg-white p-4 shadow-custom-md
          `}
        >
          <div className="min-w-0">
            <Typography.Text size="s" className="truncate">
              {field.name}
              {field.isUsed && <>&nbsp;(Used)</>}
            </Typography.Text>

            <Typography.Text size="xs" color="secondary">
              {field.quantity}&nbsp;×&nbsp;{formatMoney(field.price)}
            </Typography.Text>
          </div>

          <IconButton
            type="button"
            variant="secondary"
            size="s"
            aria-label="Remove item"
            onClick={() => remove(index)}
          >
            <TrashIcon />
          </IconButton>
        </div>
      ))}
    </>
  );
};
